// Central site settings. Everything can be overridden with environment variables at build time
// (REACT_APP_*), so the same code can be deployed on any domain.

export const BRAND = {
  name: "Ratan Market",
  short: "Ratan",
  tagline: "Official",
};

export const API_BASE = process.env.REACT_APP_API_BASE || "https://api.ratanmarket.in";
export const APK_URL = process.env.REACT_APP_APK_URL || "https://www.appnew.cloud/Ratan-Mat.apk";

// Optional Google Ads / GA4 id, e.g. AW-123456789. Nothing is loaded when it is empty.
export const GTAG_ID = process.env.REACT_APP_GTAG_ID || "";
export const GADS_DOWNLOAD_CONVERSION = process.env.REACT_APP_GADS_DOWNLOAD_CONVERSION || "";

// Public origin used for canonical URLs, Open Graph and structured data.
export const siteUrl = () =>
  (process.env.REACT_APP_SITE_URL || (typeof window !== "undefined" ? window.location.origin : "")).replace(/\/$/, "");

// Rates shown when the rates API is unavailable. Format: [label, "stake-return"].
export const FALLBACK_RATES = [
  ["Single", "10-100"],
  ["Jodi", "10-1000"],
  ["Single Patti", "10-1600"],
  ["Double Patti", "10-3200"],
  ["Triple Patti", "10-10000"],
  ["Half Sangam", "10-10000"],
  ["Full Sangam", "10-100000"],
];

// Which API field feeds which rate row.
export const RATE_FIELDS = [
  ["Single", "singleDigits"],
  ["Jodi", "jodi"],
  ["Single Patti", "singlePana"],
  ["Double Patti", "doublePana"],
  ["Triple Patti", "triplePana"],
  ["Half Sangam", "halfSangamA"],
  ["Full Sangam", "fullSangam"],
];

// Public (no login) endpoints for the Starline and Jackpot markets. They can be pointed at
// another path per deployment; when an endpoint is missing the fixed hourly slots are shown.
export const ENDPOINTS = {
  starlineGames: process.env.REACT_APP_STARLINE_GAMES || "/api/starline/getGameListWeb",
  starlineResults: process.env.REACT_APP_STARLINE_RESULTS || "/api/starlinebid/getDeclareResultWeb",
  jackpotGames: process.env.REACT_APP_JACKPOT_GAMES || "/api/GaliDisawar/getAllMarketWeb",
  jackpotResults: process.env.REACT_APP_JACKPOT_RESULTS || "/api/GaliDisawarDeclareResult/getResultWeb",
};

export const STARLINE_SLOTS = [
  "10:30 AM", "11:30 AM", "12:30 PM", "01:30 PM", "02:30 PM", "03:30 PM",
  "04:30 PM", "05:30 PM", "06:30 PM", "07:30 PM", "08:30 PM", "09:30 PM",
];
export const JACKPOT_SLOTS = [
  "10:00 AM", "11:00 AM", "12:00 PM", "01:00 PM", "02:00 PM", "03:00 PM",
  "04:00 PM", "05:00 PM", "06:00 PM", "07:00 PM", "08:00 PM", "09:00 PM",
];
